import { Button, Text, Select, Group } from "@mantine/core";
import React, { useState } from "react";
import { useServerApi } from "../../hooks/userServerApi";
import { DatePicker } from "@mantine/dates";
import { DATA_REPORT_DATE_TYPE } from "../../data/options";
import { useTranslation } from "react-i18next";
import { openFileUrl } from "../../utils/openReport";

const ConsultantReportOrder = () => {
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [dateType, setDateType] = useState("submissionDate");
  const [loading, setLoading] = useState(false);
  const [api] = useServerApi();
  const { t } = useTranslation();

  const downloadReport = async () => {
    try {
      setLoading(true);
      const result = await api.Order.getConsultantReport({
        fromDate,
        toDate,
        dateType,
      });
      setLoading(false);
      if (result?.data?.url) {
        await openFileUrl(result.data.url);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <div>
      <Text size="xs">{t("Please select the period of records.")}</Text>
      <Group mt="xs">
        <DatePicker
          title={t("From Date")}
          size="xs"
          allowFreeInput
          placeholder="From"
          onChange={(d) => setFromDate(d)}
        />
        -
        <DatePicker
          title={t("To Date")}
          size="xs"
          allowFreeInput
          placeholder="To"
          onChange={(d) => setToDate(d)}
        />
        <Text size="xs">by</Text>
        <Select
          size="xs"
          defaultValue={"submissionDate"}
          data={DATA_REPORT_DATE_TYPE}
          onChange={(type) => setDateType(type)}
        />
      </Group>
      <Button
        size="xs"
        mt="xl"
        onClick={() => downloadReport()}
        loading={loading}
      >
        {t("Download")}
      </Button>
    </div>
  );
};

export default ConsultantReportOrder;
